import React from 'react'
import small_button_bg from "../../images/small_button_bg.svg";
import call_moder from "../../images/icons/call moder.svg";
import add_player from "../../images/icons/add.svg";
import game_icon from "../../images/icons/game.svg";
import ready_team from "../../images/icons/ready_team.svg";
import './ModeratorPlayersCard.css'
import ModeratorPlayerCard from "./ModeratorPlayerCard";
import ButtonWithIcon from "../Utils/ButtonWithIcon";
import ModeratorAddPlayerPopup from "./AddPlayerPopup/ModeratorAddPlayerPopup";
import agent from "../../agent";
import ModeratorSetStatusCard from "./ModeratorSetStatusCard";
import {LOGO_SET_STATE, ROLE_SET_STATE, STATE_NAMES, STATES_USER_COUNT} from "../../constants/Constants";
import UtilsFunctions from "../../utils/UtilsFunctions";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import ModeratorPlayerCardsContainer from "./ModeratorPlayerCardsContainer";

class ModeratorPlayersCard extends React.Component {

    constructor(props) {
        super(props);
        let teams = this.props.parent.state.game_info.teams;
        let thisCardTeam = teams[this.props.index] || {name: "", users: []};

        this.state = {
            isPlayerPopupActive: false,
            name: thisCardTeam.name,
            votes: null
        }
    }

    onAddButton() {
        this.setState({
            isPlayerPopupActive: true
        })
    }

    onAddPlayersSubmit(players) {
        let game = this.props.parent.state.game_info;
        game.teams[this.props.index] = {users: players, name: this.state.name};
        this.props.parent.setState({
            game_info: game
        })
        this.onAddPlayersClose()
    }

    onAddPlayersClose() {
        this.setState({
            isPlayerPopupActive: false
        })
    }

    openTeamZoom() {
        let game = this.props.parent.state.game_info
        let teams = game.teams;
        let thisCardTeam = teams[this.props.index];
        agent.Integrations.getTeamZoom(thisCardTeam.uuid, (response) => {
            console.log(response)
            window.open(response.url, "_blank")
        });
    }

    checkSetLogoState(onFinish) {
        let game = this.props.parent.state.game_info
        let teams = game.teams;
        let thisCardTeam = teams[this.props.index];
        agent.Game.getVotes(thisCardTeam.uuid, (response) => {
            console.log(response);
            this.setState({
                votes: response
            });
            let count = 0;
            let max = -1;
            let winner = null;
            for (let playerID in this.state.votes) {
                count += this.state.votes[playerID].length;
                if (this.state.votes[playerID].length > max) {
                    max = this.state.votes[playerID].length;
                    winner = playerID;
                }
            }
            if (winner != null) {
                agent.Game.sendImageTeam(thisCardTeam.uuid, winner, resp => {
                    console.log(resp);
                });
            }
            onFinish(count >= thisCardTeam.users.length / 2);
        });
    }

    setName(ev) {
        this.setState(
            {
                name: ev.target.value
            }
        );
    }

    setStatus() {
        this.props.parent.readGame(() => {
            let game = this.props.parent.state.game_info
            let teams = game.teams;
            let thisCardTeam = teams[this.props.index];
            if (thisCardTeam.state === ROLE_SET_STATE && !UtilsFunctions.validateRolesInTeam(thisCardTeam)) {
                this.props.onError("Не у всех пользователей назначены роли или не все роли назначены");
                return;
            }
            if (thisCardTeam.state === LOGO_SET_STATE) {
                this.checkSetLogoState((isSetNextState) => {
                    if (isSetNextState) {

                        agent.Game.setState(thisCardTeam.uuid, ROLE_SET_STATE, () => {
                            this.props.parent.readGame();
                        });
                    } else {
                        this.props.onError("Подождите, пользователи не проголосовали за логотип");
                    }

                });
                return;
            }
            agent.Game.setState(thisCardTeam.uuid, thisCardTeam.state + 1, () => {
                this.props.parent.readGame();
            });
        })

    }

    debugSetStatus() {
        let game = this.props.parent.state.game_info
        let teams = game.teams;
        let thisCardTeam = teams[this.props.index];
        agent.Game.setState(thisCardTeam.uuid, 0, (response) => {
            this.props.parent.readGame()
        })
    }

    endCallModerator() {
        if (!this.isCalled)
            return;

        let game = this.props.parent.state.game_info
        let teams = game.teams;
        let thisCardTeam = teams[this.props.index];

        // Заканчиваем вызов
        agent.Moderator.endCallModerator(thisCardTeam.uuid, (response) => {
            console.log(response);
        });

        // Не ждем проверки 5 сек, а просто вызываем её
        this.props.parent.checkModeratorCalled();
    }

    sendNameOnEnter(ev) {
        if (ev.key === 'Enter') {
            this.sendName(ev);
        }
    }

    sendName(ev) {
        let game = this.props.parent.state.game_info
        let teams = game.teams;
        if (!teams) return;
        let thisCardTeam = teams[this.props.index];
        if (!thisCardTeam) return;
        agent.Team.renameTeam(thisCardTeam.uuid, ev.target.value, (response) => {
            console.log(response)
            window.location.reload();
        })
    }

    removePlayer(player) {
        let game = this.props.parent.state.game_info;
        game.teams[this.props.index].users = game.teams[this.props.index].users.filter((item) => item !== player);

        this.props.parent.setState({
            game_info: game
        })
    }

    render() {
        let game = this.props.parent.state.game_info
        let teams = game.teams;
        if (!game || !teams) return "";
        let thisCardTeam = teams[this.props.index];

        if (!thisCardTeam)
            return <h1>Вы не создали команду!</h1>;

        let playerRoomsButtons = <div className='moderator-team-card-footer-right'>
            <ButtonWithIcon onClick={() => this.props.openGameplay(thisCardTeam.uuid)}
                            background={small_button_bg}
                            icon={game_icon}
                            bgColor="#F29C14"
                            bgColorHover='#FFCE01'
                            bgColorActive='#F6C700'
                            iconColor={'white'}
                            size={50}
            />
        </div>;

        let users = [];

        for (let i = 0; i < teams.length; i++) {
            let team = teams[i];

            if (team && team.users && team !== thisCardTeam) {
                for (let j = 0; j < team.users.length; j++) {
                    users.push(team.users[j]);
                }
            }
        }

        let addPlayerPopup = <ModeratorAddPlayerPopup
            players={agent.user.availablePlayers}
            selectedPlayers={thisCardTeam.users}
            allOtherPlayers={users}
            onSubmit={this.onAddPlayersSubmit.bind(this)}
            onCancel={this.onAddPlayersClose.bind(this)}/>

        let addPlayerButton = <ButtonWithIcon onClick={this.onAddButton.bind(this)}
                                              background={small_button_bg}
                                              icon={add_player}
                                              bgColor="#259F62"
                                              bgColorHover='#2FCC7D'
                                              bgColorActive='#00FF80'
                                              iconColor={'white'}
                                              size={50}
        />;
        let playerCards = [];
        let currentTeam = teams[this.props.index];
        if (teams && teams[this.props.index]) {
            for (let k = 0; k < currentTeam.users.length; k++) {
                let user = currentTeam.users[k];
                playerCards.push(<ModeratorPlayerCard key={k} player={user} id={k} isEditable={!game.is_started}
                                                      teamFromID={currentTeam.uuid}
                                                      onRemovePlayer={this.removePlayer.bind(this)}
                                                      onDrop={(item) => {
                                                          if (item.uuid === user.uuid || user.role.indexOf(item.role) !== -1)
                                                              return

                                                          let users = [];

                                                          for (let i = 0; i < this.props.team.users.length; i++) {
                                                              let toAdd = JSON.parse(JSON.stringify(this.props.team.users[i]));
                                                              toAdd.role = toAdd.role.filter(el => el !== item.role);

                                                              if (i === k) {
                                                                  toAdd.role.push(item.role)
                                                              }

                                                              users.push(toAdd);
                                                          }

                                                          let request = {};
                                                          for (let user of users) {
                                                              request[user.uuid] = user.role;
                                                          }

                                                          agent.Game.setRole(request, r => {
                                                              this.props.parent.readGame();
                                                          });
                                                      }}
                />);
            }

        }
        let statusCards = [];
        for (let i = 0; i <= thisCardTeam.state && i < STATES_USER_COUNT; i++) {
            statusCards.push(<div key={i} className='moderator-team-card-status-container'>
                <ModeratorSetStatusCard
                    name={STATE_NAMES[i]}
                    index={i}
                    currentTeamState={thisCardTeam.state}
                    OnSetStatus={this.setStatus.bind(this)}/></div>)
        }

        let moderatorCallStyles = {
            active: {
                bgColor: "#EE3524",
                bgColorHover: '#FF3B29',
                bgColorActive: '#E41300'
            },
            inactive: {
                bgColor: "#C4C4C4",
                bgColorHover: '#B2B2B2',
                bgColorActive: '#A1A1A1'
            }
        };

        let teamsCalled = this.props.parent.state.called;
        this.isCalled = false;

        // Если массив существует и он не пустой
        if (teamsCalled && teamsCalled.length > 0) {
            // Проверяем, что в списке вызвавших есть текущая команда
            for (let team of teamsCalled) {
                if (team.name === this.state.name) {
                    this.isCalled = true;
                    break;
                }
            }
        }
        let readyTeam = <div style={{
            display: "flex",
            textAlign: "left",
            fontSize: "14",
            fontWeight: "bold",
            textTransform: "uppercase",
            color: "#259F62",
            alignItems: "center"
        }}>
            <img src={ready_team} alt={"icon"}/>
            <div style={{width: "15px"}}/>
            Фаза<br/>завершена
        </div>
        let colorStyle = this.isCalled ? "active" : "inactive";

        return <div className='moderator-team-card-container'>
            <DndProvider backend={HTML5Backend}>
                <ModeratorPlayerCardsContainer onDrop={(item) => {
                    let currentTeam = null;
                    for (let i = 0; i < teams.length; i++) {
                        let team = teams[i];
                        if (team.uuid === item.teamFromID) {
                            currentTeam = team;
                            break;
                        }
                    }
                    if (currentTeam) {
                        const data = {
                            playerID: currentTeam.users[item.id].uuid,
                            teamFromID: item.teamFromID,
                            teamToID: this.props.team.uuid
                        };

                        if (data.teamFromID === data.teamToID)
                            return;
                        agent.Team.movePlayer(data.teamFromID, data.playerID, data.teamToID, (res) => {

                        });
                    }
                }}>
                    <div className='moderator-team-card'>
                        <div className='moderator-team-card-header'>
                            <div className='moderator-team-card-input-field-container'>
                                <input
                                    className="moderator-team-card-input-field"
                                    type="text"
                                    placeholder="ИМЯ КОМАНДЫ"
                                    value={this.state.name}
                                    onChange={this.setName.bind(this)}
                                    onBlur={this.sendName.bind(this)}
                                    onKeyDown={this.sendNameOnEnter.bind(this)}/>
                            </div>
                            <ButtonWithIcon onClick={this.endCallModerator.bind(this)}
                                            background={small_button_bg}
                                            icon={call_moder}
                                            bgColor={moderatorCallStyles[colorStyle].bgColor}
                                            bgColorHover={moderatorCallStyles[colorStyle].bgColorHover}
                                            bgColorActive={moderatorCallStyles[colorStyle].bgColorActive}
                                            iconColor={'red'}
                                            size={40}/>
                        </div>
                        <div className='moderator-top-delimeter'/>
                        <div className='moderator-team-player-cards-container'>
                            {playerCards}
                        </div>


                        <div className='moderator-top-delimeter'/>
                        <div className='moderator-team-card-footer'>
                            <div>
                                {!this.props.parent.state.game_info.is_started && (!thisCardTeam || (thisCardTeam && thisCardTeam.users.length < 5))
                                    ? addPlayerButton : ""}
                                {this.props.isTeamReady ? readyTeam : ""}
                            </div>
                            {this.state.isPlayerPopupActive ? addPlayerPopup : ""}
                            {game.is_started ? playerRoomsButtons : ""}
                        </div>
                    </div>
                    <div>
                        {game.is_started && !this.props.allTeamsReady ? statusCards : ""}
                    </div>
                </ModeratorPlayerCardsContainer>
            </DndProvider>
        </div>
    }
}

export default ModeratorPlayersCard;
